import { IsTest, getLang } from "@/utils/tools";
import { isHtm } from "@/utils/const";
import { request } from "..";

// TODO 请求域名确定
const testOrigin = "https://test-sg-act.playerinfinite.com/";
const prodOrigin = "https://sg-act.playerinfinite.com/";
const origin = IsTest ? testOrigin : prodOrigin;
interface commomRes {
  code: number;
  msg: string;
  data?: any;
}

export interface RoleInfo{
  area_id: string;
  game_id: number;
  game_name: string;
  plat_id: string;
  role_name: string;
  zone_id: string;
  role_id: string;
}

const lang_type = getLang();
export const submitShare = async () => {
  const otherurl = 'api/flow/Wand-20240517031955-F4dcf036fea64';
  const htmlurl = 'api/flow/Wand-20240520075624-F8b488e43a6c7';
  const url = isHtm ? htmlurl: otherurl;
  return request
    .post<commomRes>(`${origin}${url}`,  {
      checkLogin: true,
      needLogin: true,
      lang_type,
    })
    .then((res) => res.data);
};

interface GetRoleInfoReq{
  area_id: string;
}
interface GetRoleInfoRes extends commomRes {
  data: {
    role_list: RoleInfo[];
  };
}

// @see https://yapi.intlgame.com/project/1344/interface/api/83796
export const getRoleInfo = async (params: GetRoleInfoReq) => {
  const otherurl = 'api/flow/Wand-20240517031839-F10c54e015dbe';
  const htmlurl = 'api/flow/Wand-20240520075624-F720d60c8cf24';
  const url = isHtm ? htmlurl: otherurl;
  return request
    .post<GetRoleInfoRes>(`${origin}${url}`, {
      checkLogin: true,
      needLogin: true,
      lang_type,
      ...params,
    })
    .then((res) => res.data);
};

type SaveRoleInfoRes = commomRes;
// @see https://yapi.intlgame.com/project/1344/interface/api/83816
export const saveRoleInfo = async (params: Partial<RoleInfo>) => {
  const otherurl = 'api/flow/Wand-20240517031817-F9af1dd70e1ab';
  const htmlurl = 'api/flow/Wand-20240520075624-F7979eb6eb97d';
  const url = isHtm ? htmlurl: otherurl;
  return request
    .post<SaveRoleInfoRes>(`${origin}${url}`, params)
    .then((res) => res.data);
};

interface GetLoginedInitInfoRes extends commomRes {
  data: {
    get_saved_role_info: RoleInfo; // 角色信息
    first_binding: boolean; // 是否首次绑定
    nikke_valentine_log: {
      today_make: boolean; // 今天是否制作过
    }
  };
}
// TODO htm 待确定
export const getLoginedInitInfo = async () => {
  const otherurl = 'api/flow/Wand-20240517030955-F21fdd90401c2';
  const htmlurl = 'api/flow/Wand-20240520075624-Ffc5c660999ce';
  const url = isHtm ? htmlurl: otherurl;
  return request
    .post<GetLoginedInitInfoRes>(`${origin}${url}`,  {
      checkLogin: true,
      needLogin: true,
      lang_type,
    })
    .then((res) => res.data);
};